// import React from "react";
import { UserButton, UserSkeleton } from "@/features/user-button";
import { formatRelativeTime } from "@/lib/date-tools";
import { Button } from "@/components/ui/button";
// import { showMessageBox } from "@/components/blocks/message-box";
import { Check, X } from "lucide-react";
import { useTranslation } from "@/providers/language-provider";
import { signal } from "@preact/signals-react";
// import { graphQLClient } from "@/lib/client-graphql";
// import { useChats } from "@/providers/chat-provider";
import { useSignals } from "@preact/signals-react/runtime";
import {
  receivedRequests,
  acceptFriendRequest,
  rejectFriendRequest,
  isFetching,
} from "@/pages/subs/friends/friend-manager";

export const updateReceivedRequests = signal(async () => {});

export const ReceivedRequests = () => {
  useSignals();
  const { t } = useTranslation();

  return (
    <>
      {isFetching.value ? (
        <div className="space-y-2 p-2">
          <UserSkeleton />
          <UserSkeleton />
        </div>
      ) : (
        receivedRequests.value?.map((req: any) => (
          <UserButton
            key={req._id}
            asButton={false}
            user={req.requester}
            variant="ghost"
          >
            <div className="flex items-center space-x-2">
              <span>{formatRelativeTime(req.createdAt)}</span>
              <Button
                size="sm"
                variant="default"
                onClick={() => acceptFriendRequest.value?.(req)}
              >
                <Check className="h-4 w-4 mr-1" />
                {t("Accept")}
              </Button>
              <Button
                size="sm"
                variant="destructive"
                onClick={() => rejectFriendRequest.value?.(req)}
              >
                <X className="h-4 w-4 mr-1" />
                {t("Cancel")}
              </Button>
            </div>
          </UserButton>
        ))
      )}
    </>
  );
};
